import userApi from "api/user";
import { roles } from "constants/index";
import { Button, Col, Form, Modal, Row, Select, Tooltip } from "antd";
import { useEffect, useState } from "react";
import style from './index.module.scss'
import classNames from "classnames/bind";
import { DoubleRightOutlined } from '@ant-design/icons';
import { useTranslation } from "react-i18next";

const cx = classNames.bind(style)

export default function ModalChangeStore({ id, openNotificationWithIcon, onSearch, optionsStore, data }) {
  const [openModal, setOpenModal] = useState(false);
  const [form] = Form.useForm();
  const { t } = useTranslation()

  useEffect(() => {
    if (openModal) {
      if ([roles.staff, roles.staffShop].includes(+data?.role)) {
        form.setFieldValue("shop", data?.shops[0]?.shop?._id);
        // form.setFieldValue("workedAt", data?.shops[0]?.workedAt && moment(data?.shops[0]?.workedAt));
      }
    }
  }, [openModal]);

  const onFinish = async (values) => {
    try {
      const res = await userApi.editUser(id, {
        shops: [values]
      });
      if (res?.success) {
        openNotificationWithIcon("success", t('notification'), t('transferEmployeeSuccess'));
        onCancel();
        onSearch();
      }
    } catch (error) {
      openNotificationWithIcon("error", t('error'), error?.response?.data?.message || t('error'));
    }
  };

  const onCancel = () => {
    setOpenModal(false);
    form.resetFields();
  };

  return (
    <>
      <Tooltip title={t('transfer')}>
        <Button className={cx('btn-change')} onClick={() => setOpenModal(true)}>
          <DoubleRightOutlined />
        </Button>
      </Tooltip>
      <Modal
        open={openModal}
        title={t('transferEmployee')}
        centered
        footer={null}
        onCancel={onCancel}
        width={768}
        destroyOnClose
      >
        <Form form={form} onFinish={onFinish} layout="vertical">
          <Form.Item
            name="shop"
            label={t('shop')}
            rules={[
              {
                required: true,
                message: t('required'),
              },
            ]}
          >
            <Select options={optionsStore} allowClear />
          </Form.Item>
          {/* <Form.Item
            name="workedAt"
            label={t('workStartDate')}
            rules={[{ required: true, message: t('required') }]}
            extra={t('oldStartDate', { date: moment(data?.shops[0]?.workedAt).format("YYYY-MM-DD") })}
          >
            <DatePicker
              placeholder=''
              style={{ width: "300px" }}
              format="YYYY-MM-DD"
              disabledDate={(current) => {
                let customDate = moment(data?.shops[0]?.workedAt).format("YYYY-MM-DD");
                return current && current < moment(customDate, "YYYY-MM-DD");
              }}
            />
          </Form.Item> */}
          <Row gutter={16}>
            <Col span={8} offset={4}>
              <Form.Item>
                <Button style={{ width: "100%" }} htmlType="submit">
                  Ok
                </Button>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Button style={{ width: "100%" }} onClick={onCancel}>
                {t('cancel')}
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
}
